import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Wheat } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

export default function AdminLoginPage() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { document.title = "Admin Login — Aaha Kanakam Traders"; }, []);
  useEffect(() => { if (user) navigate("/admin"); }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-forest px-4">
      <div className="w-full max-w-md bg-ivory border border-borderSubtle p-8 md:p-10">
        <Link to="/" className="flex items-center gap-3 justify-center mb-6">
          <div className="w-11 h-11 rounded-full bg-gold text-forest flex items-center justify-center"><Wheat size={20} /></div>
          <div className="text-forest font-serif text-xl">Aaha Kanakam Traders</div>
        </Link>
        <div className="eyebrow text-center mb-2">Admin Access</div>
        <h1 className="font-serif text-3xl text-forest text-center mb-8">Sign in to dashboard</h1>
        <form onSubmit={submit} className="space-y-4">
          <input data-testid="admin-email" type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full px-4 py-3 text-sm border border-borderSubtle bg-white focus:outline-none focus:border-forest" />
          <input data-testid="admin-password" type="password" required placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full px-4 py-3 text-sm border border-borderSubtle bg-white focus:outline-none focus:border-forest" />
          <button data-testid="admin-login-submit" disabled={loading} className="w-full btn-gold py-3 text-sm font-semibold tracking-wide disabled:opacity-60">
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
        <div className="mt-6 text-center">
          <Link to="/" className="text-xs text-slateneutral hover:text-forest">← Back to website</Link>
        </div>
      </div>
    </div>
  );
}
